import React, { useEffect, useState } from "react";
import { Form, Row, Col, Typography, Select, Modal } from "antd";
import { ExclamationCircleOutlined, CloseOutlined, CheckOutlined } from "@ant-design/icons";

import api from "../../../services/api";
import SelectPaginacao from "../../selects/selectPaginacao";

export default function ModalInstrucaoRemessa({ exibirModalInstrucaoRemessa, fecharModalInstrucaoRemessa, form, parcela, onOk, selecionado }) {

    const [listaInstrucao, setListaInstrucao] = useState([]);
    const [formInstrucao] = Form.useForm();

    const onCloseModal = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                fecharModalInstrucaoRemessa();
            }
        });
    };

    function onFinish(values){
        let inst = listaInstrucao.find((instrucao) => { return instrucao.isp_id === values.isp_id});
        onOk(inst);
    };

    function carregarInstrucoes() {
        if (!parcela || !exibirModalInstrucaoRemessa || !selecionado) {
            fecharModalInstrucaoRemessa();
            return;
        }
        let parSelec = null;
        let cancelados = false;
        if (Array.isArray(parcela)) {
            parSelec = parcela.filter(p => p.selecionado === true);
            cancelados = parcela.some(p => p.ntf_status === 2);
        } else {
            parSelec = parcela;
            cancelados = parcela.ntf_status === 2;
        }
        let conta = form.getFieldValue().ctc_id || parcela.ctc_id;
        if (!conta && Array.isArray(parSelec)) {
            conta = parSelec[0]?.ctc_id;
        }
        return api.get(`InstrucaoBoleto/Listar?Descricao=${conta}`).then((res) => {
            if (res.status === 200) {
                const instrucoes = res.data.items;
                if (cancelados) {
                    const codigosValidos = ['10', '18', '23', '02', '34', '46'];
                    const filtradas = instrucoes.filter(item => codigosValidos.includes(item.isp_codigo));
                    setListaInstrucao(filtradas);
                } else {
                    setListaInstrucao(instrucoes);
                }
            }
        }).catch(console.log);
    };

    const contaId = form.getFieldValue("ctc_id") || (parcela?.[0]?.ctc_id ?? parcela?.ctc_id) || '';

    return (
        <Modal centered
            title="Instrução"
            open={exibirModalInstrucaoRemessa}
            onCancel={onCloseModal}
            onOk={() => formInstrucao.submit()}
            cancelText={
                <>
                    <CloseOutlined /> Cancelar
                </>
            }
            okText={
                <>
                    <CheckOutlined /> Ok
                </>
            }
            maskClosable={false}
        >
            <Form layout="vertical" form={formInstrucao} onFinish={(values) => { onFinish(values) }}>
                <Row align="middle" gutter={[0, 8]}>
                    <Col>
                        <Typography.Text>
                            Abaixo informe a Instrução que deseja realizar.
                        </Typography.Text>
                    </Col>
                </Row>
                <Row gutter={[8, 8]}>
                    <Col span={24}>
                        <Form.Item label="Instrução" name="isp_id" rules={[{ required: true }]}>
                            <SelectPaginacao
                               url={`InstrucaoBoleto/Listar?Descricao=${contaId}`}
                                allowClear
                                nameLabel="isp_id"
                                form={formInstrucao}
                                nameValue="isp_id"
                                onChangeFunction={carregarInstrucoes}
                                setListaDados={setListaInstrucao}
                                conteudo={isp => (
                                    <Select.Option label={isp.isp_descricao} key={isp.isp_id} value={isp.isp_id}> {isp.isp_codigo} - {isp.isp_descricao} </Select.Option>
                                )}
                        
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal >
    );
}